const BaseService = require('@/services/BaseService')

const namespace = 'se-reports'

/**
 * Get all reports for a customer
 * 
 * @param {string} customerId - The customer ID
 * @param {function} cb - Success callback
 * @param {function} errorCb - Error callback
 * @returns {Promise}
 */
const getReports = (customerId, cb, errorCb) => {
  const options = {
    headers: {
      'Accept': 'application/json'
    }
  }
  return BaseService.get(`${namespace}/${customerId}`, {}, cb, errorCb, options)
}

/**
 * Download a specific report
 * 
 * @param {string} customerId - The customer ID
 * @param {string} reportId - The report ID
 * @param {string} type - The report type (default: html)
 * @param {function} cb - Success callback
 * @param {function} errorCb - Error callback
 * @returns {Promise}
 */
const downloadReport = (customerId, reportId, type = 'html', cb, errorCb) => {
  const options = {
    headers: {
      'Accept': 'application/json'
    },
    responseType: 'blob'
  }
  return BaseService.get(`${namespace}/${customerId}/report/${reportId}/download`, { type }, cb, errorCb, options)
}

export {
  getReports,
  downloadReport
}
